import type { ReactNode } from 'react';

import styled from '@emotion/styled';
import { InfoOutlined } from '@mui/icons-material';
import { ToggleButton } from '@mui/material';

import {
  black,
  blueBlack640,
  blueUltramarine050,
  blueUltramarine060,
  greyLight200,
  white,
} from '../../../theme/videa-style-tokens';

const VideaToggleButton = styled(ToggleButton)`
  text-transform: none;
  justify-content: flex-start;
  color: ${blueBlack640};
  border-color: ${white};
  width: 100%;

  &:first-of-type {
    border-radius: 1.25em 1.25em 0 0;
    background-color: ${greyLight200};
  }

  &:last-of-type {
    border-radius: 0 0 1.25em 1.25em;
    background-color: ${greyLight200};
  }

  &.Mui-selected {
    background-color: ${blueUltramarine050};
    color: ${black};
  }

  &:hover {
    background-color: ${blueUltramarine060};

    &.Mui-selected {
      background-color: ${blueUltramarine060};
    }
  }
`;

interface ConfidenceOptionProps {
  value: number;
  title: ReactNode;
  description: ReactNode;
  selectedBin: number | undefined;
  onSelect: (value: number | undefined) => void;
}

export const ConfidenceOption = ({
  value,
  title,
  description,
  selectedBin,
  onSelect,
}: ConfidenceOptionProps) => {
  return (
    <VideaToggleButton
      value={value}
      aria-label={`Confidence option ${value}`}
      selected={selectedBin === value}
      onClick={() => onSelect(value)}
    >
      <div>
        <div className="vai-block vai-text-left vai-font-semibold vai-m-1 vai-text-sm">
          {title}
        </div>
        <div className="vai-flex vai-items-center vai-gap-2 vai-text-left vai-m-1 vai-text-sm">
          <InfoOutlined />
          <span className="confidence-note">{description}</span>
        </div>
      </div>
    </VideaToggleButton>
  );
};
